import script from "./OboardLogoLoader.vue?vue&type=script&setup=true&lang=js"
export * from "./OboardLogoLoader.vue?vue&type=script&setup=true&lang=js"

import "./OboardLogoLoader.vue?vue&type=style&index=0&id=cc5bcc40&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cc5bcc40"]])

export default __exports__